<template>
  <v-tooltip v-if="status == 'error'" bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-tag v-if="status == 'error'" type="error">
          {{ $t('message.pages.videoPage.details.alert.converting.error') }}
        </v-tag>
      </div>
    </template>

    <span
      v-html="
        !isQualityScreen
          ? $t('message.pages.videoPage.details.alert.converting.errorTooltip')
          : $t(
              'message.pages.videoPage.details.alert.converting.errorTooltipScreen'
            )
      "
    ></span>
  </v-tooltip>

  <v-tooltip v-else-if="status == 'available'" bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-icon size="16" color="#4CAF50">panda-check-round</v-icon>
      </div>
    </template>
    <span>{{
      $t('message.pages.videoPage.details.alert.converting.available')
    }}</span>
  </v-tooltip>

  <v-tag type="neutral" v-else-if="status == 'waiting'">
    {{ $t('message.pages.videoPage.details.alert.converting.waiting') }}
  </v-tag>

  <v-progress-circular
    v-else-if="status == 'progress'"
    :size="16"
    width="3"
    color="primary"
    indeterminate
  />
  <v-tooltip
    v-else-if="status == 'disabled'"
    bottom
    persistent
    :close-delay="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-tag type="neutral">
          {{ $t('message.commom.disabled') }}
          <v-icon class="ml-1"> panda-help-outline </v-icon>
        </v-tag>
      </div>
    </template>
    <v-row align="center" align-content="center" justify="center" no-gutters>
      <div>
        <span
          v-html="
            $t(
              'message.pages.videoPage.details.alert.converting.disabledTooltip'
            )
          "
        ></span>
      </div>
      <div
        class="ml-1"
        style="
          display: flex;
          align-items: center;
          gap: 10px;
          pointer-events: all !important;
          z-index: 9999;
        "
      >
        <base-btn size="xsmall" type="neutral" @click="goToQuality"
          ><span class="body-bold-smaller">{{
            $t('message.affiliateVideoPage.manage')
          }}</span
          ><v-icon class="body-bold-smaller pl-2" size="20"
            >mdi-open-in-new</v-icon
          ></base-btn
        >
      </div>
    </v-row>
  </v-tooltip>
  <v-tooltip v-else-if="status == 'unavailable'" bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-tag type="neutral">
          {{ $t('message.pages.video.unavailable') }}
          <v-icon class="ml-1"> panda-help-outline </v-icon></v-tag
        >
      </div>
    </template>
    <span
      v-html="
        $t(
          'message.pages.videoPage.details.alert.converting.unavailableTooltip'
        )
      "
    ></span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'QualityStatus',
  data: () => ({
    allQualitys: ['240p', '360p', '480p', '720p', '1080p', '1440p', '2160p'],
  }),
  props: {
    status: {
      type: String,
    },
    isQualityScreen: {
      type: Boolean,
    },
  },
  methods: {
    goToQuality() {
      this.$router.push({ name: 'Quality' })
    },
  },
}
</script>
